import faker from "faker";

export const generate = (count = 10) => {
  return new Array(count)
    .fill()
    .map(_ => faker.random.word())
    .join(" ");
};

// List of catchy buzzwords
const wordList = [
  "full stack",
  "SQL",
  "React.js",
  "javascript",
  "framework",
  "security",
  "design",
  "scrum",
  "python",
  "java",
  "team player",
  "detail oriented",
  "enthusiastic"
];

// Generates a list of 10 buzzwords at a time
export const generateBuzzword = (count = 10) => {
  return new Array(count)
    .fill()
    .map(
      (element, index) =>
        wordList[Math.floor(Math.random() * Math.floor(wordList.length - 1))]
    )
    .join(" ");
};
